import { components as ReactSelectComponents, type MultiValueProps } from 'react-select';
import Checkbox from '@creditflowresearch/uilib/Checkbox';
import { AsyncSelect } from '@creditflowresearch/uilib/Select';
import Flex from '@creditflowresearch/uilib/Flex';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useParentsIssuersSection from './useParentsIssuersSection';
import { MIN_QUERY_LENGTH } from '@/creditflowresearch/application/BondScreener/constants';
import type { ICompanyOption } from './helpers';

import spaceStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

const MultiValue = (props: MultiValueProps<ICompanyOption>) => (
  <ReactSelectComponents.MultiValue { ...props }>
    { `${ props.data.label } – ${ props.data.type === 'parent' ? 'Parent' : 'Issuer' }` }
  </ReactSelectComponents.MultiValue>
);

const ParentsIssuers = () => {
  const {
    loadOptions,
    selectedOptions,
    handleChange,
    currentOptions,
    isExcluded,
    onToggleExclude,
    isHoldCoChecked,
    isOpCoChecked,
    handleHoldCoChange,
    handleOpCoChange,
  } = useParentsIssuersSection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.ParentsIssuers }
      header={ (
        <FilterSectionHeader
          title="ISSUER"
          rightSlot={ (
            <Checkbox
              label="Exclude selected"
              checked={ isExcluded }
              onChange={ onToggleExclude }
              dataTest="parentsIssuersExcludeCheckbox"
            />
          ) }
        />
      ) }
      dataTest="parentsIssuersSection"
    >
      <AsyncSelect
        isMulti
        isGrouped
        name="parentsIssuers"
        value={ selectedOptions }
        onChange={ handleChange }
        loadOptions={ loadOptions }
        useDebounce={ {
          minInputLength: MIN_QUERY_LENGTH.company,
          belowMinLengthMessage: `Search must contain at least ${ MIN_QUERY_LENGTH.company } characters`,
        } }
        filterOption={ () => true }
        defaultOptions={ currentOptions }
        placeholder="Select Parent Company or Issuer"
        dataTest="parentsIssuersSelect"
        noOptionsMessage={ () => 'No results' }
        closeMenuOnSelect={ false }
        hideSelectedOptions={ false }
        components={ { MultiValue } }
        isNarrow
      />
      <Flex gap={ 20 } className={ spaceStyles.mtl }>
        <Checkbox
          label="HoldCo"
          checked={ isHoldCoChecked }
          onChange={ handleHoldCoChange }
          dataTest="parentsIssuersHoldCoCheckbox"
        />
        <Checkbox
          label="OpCo"
          checked={ isOpCoChecked }
          onChange={ handleOpCoChange }
          dataTest="parentsIssuersOpCoCheckbox"
        />
      </Flex>
    </FilterSection>
  );
};

export default ParentsIssuers;
